import { Money } from '../ui/Money';
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import EOSBPaymentSection from '../employee-form/EOSBPaymentSection';

const EOSBDialog = ({ eosbData, employee, onClose, onUpdate }) => {
  if (!eosbData) return null;
  
  return (
    <Dialog open={!!eosbData} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>EOSB Calculation - {eosbData.employee_name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-xs text-gray-500">Years of Service</p>
              <p className="text-lg font-semibold">{eosbData.years_of_service} years</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
              <p className="text-xs text-gray-500">Basic Salary</p>
              <p className="text-lg font-semibold"><Money value={eosbData.basic_salary} digits={2} /></p>
            </div>
          </div>
          <div className="bg-green-50 p-4 rounded-lg border border-green-200">
            <p className="text-sm text-gray-600">EOSB Amount</p>
            <p className="text-3xl font-bold text-green-600"><Money value={eosbData.eosb_amount} digits={2} /></p>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-xs text-gray-500 mb-1">Calculation Details</p>
            <p className="text-sm">{eosbData.calculation_details}</p>
          </div>
          
          {/* EOSB Payment Section */}
          {employee && ['Resigned', 'Terminated'].includes(employee.employment_status) && (
            <EOSBPaymentSection
              employee={employee}
              eosbAmount={eosbData.eosb_amount}
              onUpdate={onUpdate}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EOSBDialog;
